import { openBlock, createElementBlock, createElementVNode, defineComponent, computed, normalizeClass, unref, createBlock, createCommentVNode, renderSlot, createTextVNode, toDisplayString } from 'vue';

const _hoisted_1$1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$1 = /*#__PURE__*/createElementVNode("path", {
  d: "M19.793 6.965a.77.77 0 01-.022 1.075l-9.815 9.607a1.224 1.224 0 01-1.714.006l-4.01-3.878a.77.77 0 01-.028-1.074l.684-.736a.735.735 0 011.053-.028l3.15 3.046 8.96-8.771a.735.735 0 011.054.022l.688.731z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$1 = [
  _hoisted_2$1
];

function render(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1, _hoisted_3$1))
}

const _hoisted_1 = { class: "omnica-checkbox-wrapper" };
const _hoisted_2 = { class: "omnica-checkbox__checkmark" };
const _hoisted_3 = { class: "omnica-checkbox__checkmark-icon" };
const _hoisted_4 = ["value", "name", "disabled", "checked"];
const _hoisted_5 = {
    key: 0,
    class: "omnica-checkbox__text"
};
const _hoisted_6 = {
    key: 1,
    class: "omnica-checkbox__description"
};
let counter = 0;
const __default__ = {};
var script = /*#__PURE__*/ defineComponent(Object.assign(Object.assign({}, __default__), { __name: 'UiCheckbox', props: {
        /** Атрибут name нативного поля ввода */
        name: {
            type: String,
            default: () => 'ui-checkbox-' + ++counter,
        },
        /** Значение модели используемое с директивой v-model */
        model: {
            type: null,
            default: undefined,
        },
        /** Атрибут value нативного поля ввода */
        value: {
            type: null,
            default: undefined,
        },
        /** Не определенный. Не переключается */
        indeterminate: {
            type: Boolean,
            default: false,
        },
        /** Заголовок справа от чекбокса */
        label: {
            type: String,
            default: '',
        },
        /** Дополнительное описание под заголовком */
        description: {
            type: String,
            default: '',
        },
        /** Заблокированный */
        disabled: {
            type: Boolean,
            default: false,
        },
        /**
         * Значение, которое возвращает событие change, когда чекбокс включен.
         *  Например, можно инвертировать возвращаемые значения чекбокса, изменив значения trueValue и falseValue на противоположные дефолтным
         */
        trueValue: {
            type: null,
            default: true,
        },
        /**
         * Значение, которое возвращает событие change, когда чекбокс выключен.
         *  Например, можно инвертировать возвращаемые значения чекбокса, изменив значения trueValue и falseValue на противоположные дефолтным
         */
        falseValue: {
            type: null,
            default: false,
        },
        /** Функция для проверки равенства элементов. Используется в случае, если value, trueValue или falseValue являются объектами  */
        equalsFn: {
            type: Function,
            default: (a, b) => a === b,
        },
        /** Уменьшает размер бокса */
        small: {
            type: Boolean,
            default: false,
        },
    }, emits: [
        /** Переключение чекбокса */
        'change',
        /** Изменение значения модели */
        'update:model',
    ], setup(__props, { emit }) {
        const props = __props;
        const isArray = Array.isArray;
        const equals = (a, b) => props.equalsFn(a, b);
        const contains = (array, value) => array.some(v => equals(v, value));
        const checked = computed(() => {
            return isArray(props.model)
                ? contains(props.model, props.value)
                : equals(props.model, props.trueValue);
        });
        const calculate = (checked) => {
            if (isArray(props.model)) {
                return checked
                    ? (contains(props.model, props.value) ? props.model : [...props.model, props.value])
                    : [...props.model].filter(v => !equals(v, props.value));
            }
            return checked ? props.trueValue : props.falseValue;
        };
        const onChange = (event) => {
            const input = event.target;
            const value = calculate(input.checked);
            emit('change', value);
            emit('update:model', value);
        };
        return (_ctx, _cache) => {
            return (openBlock(), createElementBlock("div", _hoisted_1, [
                createElementVNode("label", {
                    class: normalizeClass({
                        'omnica-checkbox': true,
                        'omnica-checkbox_small': __props.small,
                        'omnica-checkbox_checked': unref(checked),
                        'omnica-checkbox_indeterminate': __props.indeterminate,
                        'omnica-checkbox_disabled': __props.disabled,
                    })
                }, [
                    createElementVNode("span", _hoisted_2, [
                        createElementVNode("span", _hoisted_3, [
                            (unref(checked) && !__props.indeterminate)
                                ? (openBlock(), createBlock(unref(render), {
                                    key: 0,
                                    class: "omnica-checkbox__checkmark-image"
                                }))
                                : createCommentVNode("v-if", true)
                        ]),
                        createElementVNode("input", {
                            value: __props.value,
                            name: __props.name,
                            disabled: __props.disabled,
                            checked: unref(checked),
                            type: "checkbox",
                            class: "omnica-checkbox__checkmark-input",
                            onChange: onChange
                        }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_4)
                    ]),
                    (__props.label || __props.description || _ctx.$slots.default)
                        ? (openBlock(), createElementBlock("span", _hoisted_5, [
                            (__props.label || _ctx.$slots.default)
                                ? (openBlock(), createElementBlock("span", {
                                    key: 0,
                                    class: normalizeClass({
                                        'omnica-checkbox__label': true,
                                        'omnica-checkbox__label_muted': __props.disabled,
                                    })
                                }, [
                                    createCommentVNode(" @slot Заголовок "),
                                    renderSlot(_ctx.$slots, "default", {}, () => [
                                        createTextVNode(toDisplayString(__props.label), 1 /* TEXT */)
                                    ])
                                ], 2 /* CLASS */))
                                : createCommentVNode("v-if", true),
                            (_ctx.$slots.description || __props.description)
                                ? (openBlock(), createElementBlock("span", _hoisted_6, [
                                    createCommentVNode(" @slot Описание "),
                                    renderSlot(_ctx.$slots, "description", {}, () => [
                                        createTextVNode(toDisplayString(__props.description), 1 /* TEXT */)
                                    ])
                                ]))
                                : createCommentVNode("v-if", true)
                        ]))
                        : createCommentVNode("v-if", true)
                ], 2 /* CLASS */)
            ]));
        };
    } }));

script.__file = "packages/checkbox/src/UiCheckbox.vue";

export { script as default };
